import { render, staticRenderFns } from "./MassMemoryDlsTable.vue?vue&type=template&id=3662e3e8"
import script from "./MassMemoryDlsTable.vue?vue&type=script&lang=js"
export * from "./MassMemoryDlsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports